import { GHLLanguageKeys as e } from "./ghl-ui.es255.js";
const r = {
  name: e.portuguesePortugal,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Claro",
    more: "mais",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "A carregar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Claro",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Tempo",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar Mês",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de Início",
    endDatePlaceholder: "Data de término",
    startDatetimePlaceholder: "Data e Hora de Início",
    endDatetimePlaceholder: "Data e Hora de Fim",
    startMonthPlaceholder: "Mês de Início",
    endMonthPlaceholder: "Fim do mês",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecione tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Claro",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Alvo"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Claro"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Tempo",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "página",
    next: "Seguinte",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "A carregar"
  },
  Input: {
    placeholder: "Por favor, introduza"
  },
  InputNumber: {
    placeholder: "Por favor, introduza"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Temas",
    clearAllVars: "Limpar todas as variáveis",
    clearSearch: "Limpar pesquisa",
    filterCompName: "Nome do Componente de Filtro",
    filterVarName: "Nome da Variável de Filtro",
    import: "Importar",
    export: "Exportar",
    restore: "Repor para o Padrão"
  },
  Image: {
    tipPrevious: "Imagem anterior (←)",
    tipNext: "Próxima Imagem (→)",
    tipCounterclockwise: "Anticlockwise",
    tipClockwise: "No sentido dos ponteiros do relógio",
    tipZoomOut: "Afastar o zoom",
    tipZoomIn: "Ampliar",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Ampliar para o tamanho original"
  },
  SortFilter: {
    heading: "Classificar e filtrar",
    sortHeading: "Classificar por",
    newestFirst: "Mais recentes primeiro",
    oldestFirst: "Mais antigos primeiro",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "Nenhum resultado correspondente encontrado"
  }
};
export {
  r as ptPT
};
